import { st } from './state';

/** Debug-only logging — silent unless init({ debug: true }). */
export function dlog(...args: unknown[]): void {
	if (st.debug_) {
		try {
			console.log('[l3ns]', ...args);
		} catch {}
	}
}

/**
 * Wrap any function so a thrown error can never reach the host page.
 * Every public entry point and every event listener goes through this.
 */
export function safe<A extends unknown[], R>(fn: (...args: A) => R): (...args: A) => R | undefined {
	return (...args: A) => {
		try {
			return fn(...args);
		} catch (err) {
			dlog('err', err);
		}
	};
}
